import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../Context/AuthContext";
import { FaEnvelope, FaEye, FaEyeSlash, FaLock } from "react-icons/fa";
import ErrorMessage from "../Helpers/ErrorMessage";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const navigate = useNavigate();
  const { login } = useAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await login(email, password);
      navigate("/"); // Redirect on success
    } catch (error) {
      // Error is handled in AuthContext
      setErrorMessage(
        error.response
          ? error.response.data.message
          : "Network error, please try again later"
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    // <div className="min-h-screen flex items-center justify-center bg-gray-100 py-12 px-4 sm:px-6 lg:px-8 font-sans">
    //   <div className="max-w-md w-full space-y-6 bg-white p-8 rounded-md shadow-md">
    //     <h1 className="text-center text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900">
    //       Login
    //     </h1>

    //     <ErrorMessage message={errorMessage} />

    //     <form onSubmit={handleLogin} className="space-y-6">
    //       {/* Email Input */}
    //       <div className="relative">
    //         <label
    //           htmlFor="email"
    //           className="block text-sm sm:text-base font-medium text-gray-700 mb-1"
    //         >
    //           Email
    //         </label>
    //         <div className="relative">
    //           <input
    //             type="email"
    //             id="email"
    //             value={email}
    //             onChange={(e) => setEmail(e.target.value)}
    //             className="w-full px-4 py-2 pl-10 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:outline-none text-sm sm:text-base"
    //             placeholder="Enter your email"
    //             required
    //           />
    //           <FaEnvelope className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-base sm:text-lg" />
    //         </div>
    //       </div>

    //       {/* Password Input */}
    //       <div className="relative">
    //         <label
    //           htmlFor="password"
    //           className="block text-sm sm:text-base font-medium text-gray-700 mb-1"
    //         >
    //           Password
    //         </label>
    //         <div className="relative">
    //           <input
    //             type={showPassword ? "text" : "password"}
    //             id="password"
    //             value={password}
    //             onChange={(e) => setPassword(e.target.value)}
    //             className="w-full px-4 py-2 pl-10 pr-10 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:outline-none text-sm sm:text-base"
    //             placeholder="Enter your password"
    //             required
    //           />
    //           <FaLock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-base sm:text-lg" />
    //           <button
    //             type="button"
    //             onClick={() => setShowPassword(!showPassword)}
    //             className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
    //           >
    //             {showPassword ? (
    //               <FaEyeSlash className="text-base sm:text-lg" />
    //             ) : (
    //               <FaEye className="text-base sm:text-lg" />
    //             )}
    //           </button>
    //         </div>
    //       </div>

    //       <button
    //         type="submit"
    //         disabled={isLoading}
    //         className={`w-full py-2 rounded-md text-white font-medium text-sm sm:text-base transition duration-200 ${
    //           isLoading
    //             ? "bg-indigo-300 cursor-not-allowed"
    //             : "bg-indigo-600 hover:bg-indigo-700"
    //         }`}
    //       >
    //         {isLoading ? "Logging in..." : "Login"}
    //       </button>
    //     </form>

    //     <div className="text-center text-sm sm:text-base text-gray-600 space-y-2">
    //       <p>
    //         <a
    //           href="/forgot-password"
    //           className="text-indigo-600 hover:underline"
    //         >
    //           Forgot Password?
    //         </a>
    //       </p>
    //       {/* <p>
    //         New here?{" "}
    //         <a href="/signup" className="text-indigo-600 hover:underline">
    //           Create an account
    //         </a>
    //       </p> */}
    //     </div>
    //   </div>
    // </div>

    <div class="flex items-center justify-center h-screen bg-gray-100">
      <div class="flex w-[60%] h-[75%] border-1 border-gray-800">
        <div class="flex-1 relative bg-blue-300 border-gray-500 flex items-center justify-center">
          <img
            src="https://images.unsplash.com/photo-1593642532973-d31b6557fa68?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
            alt="Inventory system"
            className="object-cover w-full h-full"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src =
                "https://via.placeholder.com/800x600.png?text=Image+Unavailable";
            }}
          />
          <div className="absolute inset-0 bg-black/50 flex items-center justify-center px-6 text-center">
            <div>
              <h2 className="text-white text-2xl font-bold leading-tight mb-2">
                Smart Inventory System
              </h2>
              <p className="text-white text-sm opacity-90">
                Track stock. Save time. Stay in control.
              </p>
            </div>
          </div>
        </div>
        <div className="flex-1 flex items-center justify-center bg-white px-6 py-12">
          <div className="max-w-md w-full">
            {/* Error Message (if any) */}
            <ErrorMessage message={errorMessage} />

            <h2 className="text-4xl font-extrabold text-gray-800 mb-2">
              Welcome Back
            </h2>
            <p className="text-sm text-gray-500 mb-6">
              Login to manage your inventory, suppliers, and reports.
            </p>

            <form onSubmit={handleLogin} className="space-y-6">
              {/* Email Input */}
              <div className="relative">
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  Email
                </label>
                <div className="relative">
                  <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full px-4 py-2 pl-10 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:outline-none text-sm"
                    placeholder="Enter your email"
                    required
                  />
                  <FaEnvelope className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                </div>
              </div>

              {/* Password Input */}
              <div className="relative">
                <label
                  htmlFor="password"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  Password
                </label>
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="w-full px-4 py-2 pl-10 pr-10 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:outline-none text-sm"
                    placeholder="Enter your password"
                    required
                  />
                  <FaLock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                disabled={isLoading}
                className={`w-full py-2 rounded-md text-white font-medium text-sm transition duration-200 ${
                  isLoading
                    ? "bg-indigo-300 cursor-not-allowed"
                    : "bg-indigo-600 hover:bg-indigo-700"
                }`}
              >
                {isLoading ? "Logging in..." : "Login"}
              </button>
            </form>

            {/* Footer */}
            <div className="text-center text-sm text-gray-600 mt-6 space-y-2">
              <p>
                <a
                  href="/forgot-password"
                  className="text-indigo-600 hover:underline"
                >
                  Forgot Password?
                </a>
              </p>
              {/* Uncomment if you want signup */}
              {/* <p>
              New here?{" "}
              <a href="/signup" className="text-indigo-600 hover:underline">
                Create an account
              </a>
            </p> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
